<template>
    <div>
        <title>券卡出库</title>

        <section class="cardCon">
            <main class="cardMain">
              <!-- S 券卡验证 -->
              <div class="topFlex">
                <el-form :inline="true" :model="searchClsForm" class="demo-form-inline cardForm">
                  <!-- <el-form-item class="switSelect">
                    <el-select v-model="cardTypeVal">
                        <el-option label="手机号码" :value="0"></el-option>
                        <el-option label="企业会员" :value="1"></el-option>
                    </el-select>
                  </el-form-item> -->
                  <!-- 手机号 -->
                  <template>
                      <el-form-item class="switSelect">
                        <el-select v-model="scanstyle">
                          <el-option label="单个录入" :value="0"></el-option>
                          <el-option label="批量导入" :value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <span v-if="scanstyle == 0">
                        <el-form-item>
                            <el-input v-model="searchClsForm.phone" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="本次绑定" class="codeNum">
                          <el-input-number v-model="searchClsForm.num" :step="1" step-strictly :min="1"  @change="changeNum"></el-input-number>
                          <i>张电子券</i>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getSubmit">验证</el-button>
                        </el-form-item>
                      </span>
                      <span v-else>
                        <el-form-item class="fileForm">
                            <el-upload
                                name="files"
                                ref="imgUpload"
                                :action="httpUrl"
                                  :accept="'.xls,.xlsx'"
                                :show-file-list="false"
                                :before-upload="beforeAvatarUpload"
                                :on-success="handleAvatarSuccess"
                                :on-error="uploadError"
                              >
                              <el-input v-model="fileList" placeholder="点击选择导入文件" readonly></el-input>
                            </el-upload>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getTxt" :loading="vloadings">上传</el-button>
                            <el-link  type="primary" class="icondownload" :underline="false" href="https://presale.jhtsoft.com/%E7%94%B5%E5%AD%90%E5%88%B8%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls">点击此处下载示例文件</el-link>
                        </el-form-item>
                      </span>
                  </template>
                  <!-- 企业会员 -->
                  <template v-if="cardTypeVal == 1">
                      <el-form-item v-if="!member">
                          <el-button type="primary" @click="getShowChoseMem">选择会员</el-button>
                      </el-form-item>
                      <el-form-item v-if="member">
                        <p class="inlineMember">
                          <a>
                            <img v-if="member.hpurl" :src="member.hpurl" />
                            <img v-else src="https://presale.jhtsoft.com/picms/c47519dc61feb.png" alt="会员头像">
                            </a>
                          <span>
                            <i>昵称：</i><em class="textFl">{{member.nickname}}</em>
                            <b :class="[{'iconmale':member.sex==0,'iconfemale':member.sex==1}]"></b>
                          </span>
                          <span>
                            <i>会员等级：</i><em class="textFl">{{member.mlevelname|| '新手会员'}}</em>
                          </span>
                          <span>
                            <i>手机号：</i><em>{{member.mphone ||"--"}}</em>
                          </span>
                          <el-link type="primary" :underline="false" @click="getShowChoseMem(1)">修改</el-link>
                          <small class="iconclose" @click="showMber"></small>
                        </p>
                      </el-form-item>
                      <el-form-item label="本次绑定" class="codeNum">
                        <el-input-number v-model="searchClsForm.num" :step="1" step-strictly :min="1" @change="changeNum"></el-input-number>
                        <i>张电子券</i>
                      </el-form-item>
                  </template>
                </el-form>
                <!-- <span class="restNum">可用电子券：<b class="redColor">{{remainder}}</b></span> -->
                <span class="restNum">
                  <template v-if="clientElectNum==undefined || showElectNumType">
                    门店可用电子券：<b class="blueColor">{{storeElectNum}}</b>
                  </template>
                  <template v-else>
                    企业可用电子券：<b class="redColor">{{clientElectNum}}</b>，
                    门店可用电子券：<b class="blueColor">{{storeElectNum}}</b>
                  </template>
                </span>
              </div>
              <!-- E 券卡验证 -->
              <section class="cardWrap" v-if="cardTypeVal == 0">
                <!-- S 券卡编码 -->
                <p class="commonTit"><b>手机号码</b><em> (共 <i class="commonNum">{{openlist.length}}</i> 条)</em></p>
                <!-- 手机号 -->
                <template v-if="cardTypeVal == 0">
                    <ul class="flexUpDownCenter cardTextWrap">
                        <li class="flexBet" v-for="(item, index) in openlist" :key="index">
                            <p>
                                <b>{{item.phone}}</b>
                                <small>共 <i>{{item.num}}</i> 张</small>
                            </p>
                            <span @click="remove(item.phone,index,item.num)">
                                <i title="删除" class="icondel"></i>
                            </span>
                        </li>
                    </ul>
                </template>
              </section>
            </main>
                <CardOut :type="1" :scanstyle="cardTypeVal" @update="update" :num="numbersd" :flowtype="cardTypeVal" :membercode="member.mcode"></CardOut>
                <!-- S 选择会员 -->
                <MemberChose :needdesensitizequery="1" :memberLists="member" :memberChoseDialogVisible="memberChoseDialogVisible" @selected="members" @closeChild="getCloseMemberCld"></MemberChose>
                <!-- E 选择会员 -->
        </section>

    </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from "@/apis/api.js";
export default {
  name: "CardsOut",
  // ==================================== 组件====================================
  components: {
    CardOut: resolve => require(["@/components/CardsFolder/CardOut.vue"],resolve), // 出库组件
    MemberChose: resolve =>require(["@/components/common/MemberChose.vue"], resolve), //选择会员
  },
  data() {
    return {
      remainder:0,//总部登录-数值类型为企业电子券余量，门店登录-对象类型
      scanstyle:0,//电子券数量类型：0：单个手机号录入，1：批量手机号导入
      fileList:'',
      httpUrl: '', //txt上传路径
      vloadings:false,
      numbersd:'', //数量
      show:true,
      show1:true,
      member:'',
      openlist:[],
      cover:'cover',// 券卡验证组件传值
      cardTypeVal: 0, //券卡出库类型，默认单码扫描
      codeDialogVisible: false, //覆盖定义弹框，默认false不显示
      searchClsForm: {
        num:1,//
        phone: "", //单码扫描
        show: [], //覆盖定义
        sserial: "", //序列号开始
        eserial: "", //序列号结束
        excelURL: "" //文本导入
      }, // 编码验证表单
      labelPosition: "right", //labe文字右对齐
      giftVisible: false, //选择兑换礼券商品弹出框
      goodsNum: 1, //可选商品数量
      // 多专区选商品
      editNamePop: -1, //修改多专区名称弹窗
      editableTabsValue: "1", //当前选中的专区name名
      currentIndex: 1, //当前选中专区index
      tabIndex: 2, //被执行的tab
      addIndex: 1, //添加时的index
      storeCheckDialogVisible:false,//门店选择弹框
      memberChoseDialogVisible: false, //选择会员弹框
      storeChoseDialogVisible: false, //选择门店弹框
      giftChoseDialogVisible: false, //选择兑换礼券弹框
      goodsChoseDialogVisible: false, //选择可选商品弹框
      memberCon:false,//选中的会员信息
      optArea:false, //可选配送区域弹窗
      selectedCityDlg:false, //已选城市弹窗
      clientElectNum: undefined,// 门店登录时-企业可用电子券余量
      storeElectNum: undefined,// 门店登录时-门店可用电子券余量
    };
  },
  // 监听
  watch: {
    'searchClsForm.num':function(val){
      this.numbersd = val;
    },
    'scanstyle':function(val,oldval){
      if(this.show1){
            if(this.openlist.length>0){
              this.$confirm('该操作将会清空之前数据?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                      this.show1 = true;
                      this.ecodeinfoInit();
                      this.searchClsForm.phone ='';
                      this.searchClsForm.num =1;
                      this.searchClsForm.excelURL='';
                      this.fileList ='';
                      this.openlist =[];
                      this.numbersd ='';
                  }).catch(() => {
                    this.scanstyle = oldval;
                    this.show1 = false;
                    setTimeout(()=>{
                    this.show1 = true;
                    console.log(11)
                    },10)
                  });
          }else{
            this.ecodeinfoInit();
            this.searchClsForm.phone ='';
            this.searchClsForm.num =1;
            this.searchClsForm.excelURL='';
            this.fileList ='';
            this.openlist =[];
            this.numbersd ='';
          }
      }

    },
    'cardTypeVal':function(val, oldval){
      this.searchClsForm.num =1;
        if(val==1){
              this.numbersd = this.searchClsForm.num;
        }
        if(this.openlist.length>0&&this.show){
               this.$confirm('该操作将会清空之前数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                  this.show = true;
                  this.ecodeinfoInit();
                  this.searchClsForm.num =1;
                  this.member ='';
                  this.searchClsForm.phone ='';
                  this.openlist=[];
                  this.searchClsForm.excelURL='';
                  this.numbersd ='';
              }).catch(() => {
                this.show = false;
                this.cardTypeVal = oldval;
                setTimeout(()=>{
                 this.show = true;
                },10)
              });
        }else if(this.member!=''&&this.show){
            this.$confirm('该操作将会清空之前数据?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      }).then(() => {
                        this.show = true;
                        this.ecodeinfoInit();
                        this.searchClsForm.num =1;
                        this.member ='';
                        this.searchClsForm.phone ='';
                        this.openlist=[];
                        this.searchClsForm.excelURL='';
                        this.numbersd ='';
                      }).catch(() => {
                        this.show = false;
                        this.cardTypeVal = oldval;
                        setTimeout(()=>{
                        this.show = true;
                        },10)
                      });
        }else{
            this.ecodeinfoInit();
            this.searchClsForm.phone ='';
            this.searchClsForm.num =1
            this.openlist=[];
            this.member ='';
            this.searchClsForm.excelURL='';
            this.numbersd ='';
         }
    }
  },
  computed: {
    showElectNumType(){
      console.log('企业电子券余量和门店可用电子券余量判断')
      if(this.clientElectNum!=undefined&&this.storeElectNum!=undefined){
        if(this.clientElectNum>=this.storeElectNum){
          // 企业电子券余量>=门店可用电子券余量，只显示门店可用电子券余量
          console.log('企业电子券余量>=门店可用电子券余量，只显示门店可用电子券余量')
          return true
        }else if(this.clientElectNum<this.storeElectNum){
          // 企业电子券余量<门店可用电子券余量，同时显示门店可用电子券余量和企业可用电子券余量
          console.log('企业电子券余量<门店可用电子券余量，同时显示门店可用电子券余量和企业可用电子券余量')
          return false
        }
      }
    }
  },
  // ============================================== 方法 ==============================================
  methods: {
    // 校验输入的电子券卡数量
    changeNum(){
      if(this.cardTypeVal == 0 && this.searchClsForm.num > 20){
        MessageBox.alert('每个号码最多绑定20张电子券！', '确认提示', {
          confirmButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.searchClsForm.num = 20
        }).catch(() => {});
      }else if(this.cardTypeVal == 1 && this.searchClsForm.num > 500){
        MessageBox.alert('每位会员最多绑定500张电子券！', '确认提示', {
          confirmButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.searchClsForm.num = 500
        }).catch(() => {});
      }
    },
    showMber(){
      this.member ='';
      this.cardTypeVal = 0;
    },
    update(val){
			this.openlist =[];
      this.ecodeinfoInit();
      this.getNumberOfUnusedEcodeinfo();
      this.searchClsForm= {
          num:1,//
          phone: "", //单码扫描
          show: [], //覆盖定义
          sserial: "", //序列号开始
          eserial: "", //序列号结束
          excelURL: "" //文本导入
       }; // 编码验证表单
    },
    // 删除
    remove(phone,index,num){
      Api.ECODE_REMOVEFROMSESSION({phone:phone}).then(res =>{
        if(res.data.status=="200"){
          this.openlist.splice(index, 1);
          this.numbersd =res.data.data.num;
          this.$message(res.data.message);
        }else{
           this.$message.error(res.data.message);
        }
      })
    },
    // 获取会员
    members(val){
      this.member = val
    },
    // 打开选择会员弹窗
    getShowChoseMem() {
      this.memberChoseDialogVisible = true;
    },
    // 关闭选择会员弹窗
    getCloseMemberCld() {
      this.memberChoseDialogVisible = false;
      this.memberCon = true;
    },
    // 编码验证
    getSubmit() {
      let param ={};
      if(this.scanstyle==0){
          param = {
            scanstyle:0,
            phone:this.searchClsForm.phone,
            num:this.searchClsForm.num
          }
      }else{
          param = {
            scanstyle:1,
            excelURL:this.searchClsForm.excelURL
          }
      }
      Api.ECODEINFOPHONESCAN(param).then(res =>{
        if(res.data.status=="200"){
           this.vloadings = false;
           if(this.scanstyle==1){
              this.searchClsForm.excelURL ='';
              this.fileList='';
             let list = res.data.data.elist;
             list.map((item,index)=>{
               this.openlist.push({phone:item.phone,num:item.num})
             })
           }else{
              this.openlist.push({phone:this.searchClsForm.phone,num:this.searchClsForm.num})
              this.searchClsForm.phone ='';
              this.searchClsForm.num = 1;
              this.numbersd = res.data.data.num;
              this.searchClsForm.phone='';
           }
        }else{
          this.vloadings = false;
          this.searchClsForm.phone=''
          this.$message.error(res.data.message);
        }
      })
    },
    // 初始化
    ecodeinfoInit(){
     Api.ECODEINFOINIT().then(res =>{
        if(res.data.status=="200"){
          console.log(res.data.message);
        }
     })
    },
    // 上传失败
    uploadError(err,file,list) {
        this.searchClsForm.excelURL ='';
        this.fileList='';
        this.$message.error('上传失败！');
    },
    //上传图片类型限制
    beforeAvatarUpload(file) {
        console.log(file, '类型')
            // const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpg';
            let isJPG = false;
            if(file.type == 'application/vnd.ms-excel' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                isJPG = true
                this.fileList=file.name;
            }
            // const isLt1M = file.size / 1024 / 1024 < 1;
            if (!isJPG) {
              this.fileList='';
                this.$message.error('请选择对应的.xls/.xlsx文件上传！');
            }
            // if (!isLt1M) {
            //     this.$emit("getLoad",false)
            //     this.$message.error('上传图片大小不能超过 1MB!');
            // }
            // return isJPG && isLt1M;
            return isJPG
    },
    //上传成功
    handleAvatarSuccess(res, file) {
        let imgtxt = res.url;
        if(res.flag){
          this.searchClsForm.excelURL =imgtxt;
        }else{
          this.$message.error('上传文件失败！');
        }
    },
    getTxt(){
      if(!this.searchClsForm.excelURL){
        this.$message.error('请选择对应的.xls/.xlsx文件上传！');
        return
      }
      this.vloadings = true;
      this.getSubmit();
    },
    getNumberOfUnusedEcodeinfo(){
      Api.GET_NUMBEROFUNUSEDECODEINFO().then(res =>{
         if(res.data.status=="200"){
            let { clientElectNum, storeElectNum } = res.data.data;
              this.clientElectNum=clientElectNum
              this.storeElectNum=storeElectNum
              console.log('有值')
            }else{
            // this.remainder = 0;
            this.clientElectNum=undefined;
            this.storeElectNum=undefined;
         }
      })
    }

  },
  mounted() {
    this.ecodeinfoInit();
    this.getNumberOfUnusedEcodeinfo();
    this.$nextTick(() => {
           this.httpUrl = Api.UPLOADFILE();
      });
  },

};
</script>
<style scoped>
.cardCon {
  position: relative;
  padding: 20px 20px 85px;
  height: calc(100% - 169px);
}
.cardWrap {
  margin-top: 10px;
}
/* S 券卡编码 */
.cardTextWrap {
  margin: 30px 0 20px 0;
  max-height: 250px;
  overflow-y: auto;
  position: relative;
}
.cardTextWrap {
  -o-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.cardTextWrap li {
  margin-bottom: 10px;
  padding: 0 10px 0 20px;
  height: 40px;
}
.cardTextWrap li strong {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cardTextWrap li span i {
  font-size: 18px;
  cursor: pointer;
  color: #333;
}
.cardTextWrap li span i:hover {
  color: var(--main-color);
}
.cardTextWrap li {
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.cardTextWrap li:hover {
  background: #f2f4f7;
}
@media (max-width: 1500px) {
  .cardTextWrap li {
    padding-left: 10px;
  }
  .cardTextWrap li strong {
    width: 17%;
  }
}
@media (max-width: 1310px) {
  .cardTextWrap li strong {
    width: 13%;
  }
}
.cardTextWrap li:hover span {
  display: inline-block;
}
.switSelect >>> .el-select{ width:120px; }
.switSelect >>> .el-select .el-input {width:100%;}
.cardTextWrap li {
  width: 20%;
  color: #999;
}
.cardTextWrap li b {
  color: #333;
}
.cardTextWrap li p {
  width: 92%;
}
.cardTextWrap li p small {
  margin-left: 1%;
  font-size: 14px;
}
.cardTextWrap li p small i {
  color: #F7615E;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, Verdana;
}
.cardTextWrap li span {
  display: none;
  width: 8%;
  text-align: center;
}
.cardTextWrap li strong {
  max-width: 24%;
  display: inline-block;
  vertical-align: middle;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, Verdana;
}
.zoneHead {
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
@media (max-width: 1310px) {
  .cardCon header a {
    padding: 0 16px;
  }
}

.codeNum>>>.el-input{width:auto!important;}
.codeNum i{margin-left:12px;}

.inlineMember {padding:0 10px; border:solid 1px #dcdfe6; height:38px; line-height:38px;}
.inlineMember a:first-child {position:relative; width:30px; height:30px; margin:3px 0; border-radius:50%; overflow: hidden; border:solid 1px #ebeef5; }
.inlineMember img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:30px; }
.inlineMember * {display:inline-block; vertical-align: top; font-size: 14px;}
.inlineMember span {margin-right:10px;}
.inlineMember i {color:#999;}
.inlineMember em {max-width:150px;width:auto;}
.inlineMember .iconmale {font-size: 18px;color:var(--main-color);}
.inlineMember .iconfemale {font-size: 18px;color:#f56c6c;}
.inlineMember small{ font-size:14px; cursor: pointer; }
.inlineMember small:hover{ color: var(--main-color); }

.topFlex {display:-webkit-flex;display:flex;-webkit-justify-content:space-between; justify-content: space-between;}
.fileForm {position: relative;}
.icondownload {margin-left:5px;}
.icondownload:hover {opacity: .8;}
.restNum {margin-bottom:22px;margin-right:60px;line-height:40px;font-weight:bold; white-space: nowrap;}
.restNum b {font-weight:bold;}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CardsElectron/CardManage/CardsElectronOut.vue